module.exports = __webpack_public_path__ + "distribution/img/timg-21@2x.3def766c.png";